var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.126 28.326 19.096 2.954C18.525 1.64 17.688 1 16.58 1h-.886c-1.11 0-1.948.643-2.515 1.954L8.815 14.009H5.514c-.99.002-1.792.839-1.8 1.874v.026c.008 1.037.81 1.873 1.8 1.877h1.774l-4.164 10.54c-.08.231-.121.474-.124.72 0 .59.172 1.053.493 1.413.319.36.763.54 1.331.54a1.75 1.75 0 0 0 1.035-.36c.318-.23.541-.566.712-.95l4.586-11.903h3.18c.988-.004 1.79-.842 1.8-1.877v-.05c-.01-1.037-.812-1.876-1.8-1.877h-1.7l3.498-9.126 9.538 24.83c.173.385.394.72.715.951.3.229.663.356 1.036.36.566 0 1.01-.18 1.33-.54.32-.36.492-.823.492-1.414a1.77 1.77 0 0 0-.122-.72v.002z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAave);
export default __webpack_public_path__ + "static/media/AAVE.2c78d359d2f8c79f49ea1e9e222566f5.svg";
export { ForwardRef as ReactComponent };